import {ChangeDetectorRef, Component, EventEmitter, OnDestroy, Output} from "@angular/core";
import {Subscription} from "rxjs";
import {OrderModel} from "../order.model";
import {DealEvents} from "../../deal/deal-events";
import {OrderEvents} from "../order-events";
import {EntitlementStatus} from "../../deal/entitlement-entity.model";

@Component({
    selector: "woa-order-summary-icon",
    templateUrl: "./order-summary-icon.component.html"
})
export class OrderSummaryIconComponent implements OnDestroy {
    @Output() onOrderSummary: EventEmitter<void> = new EventEmitter<void>();

    itemCount: number = 0;
    highlighted = false;
    private subscriptions: Subscription = new Subscription();

    constructor(public orderModel: OrderModel,
                private changeDetectorRef: ChangeDetectorRef) {
        this.itemCount = this.orderModel.totalItems;
        if (this.itemCount || DealEvents.currentEntitlementStatus$.value === EntitlementStatus.APPLIED) {
            this.highlight();
        }

        this.subscriptions.add(OrderEvents.orderChanged$.subscribe(() => {
            if (this.itemCount !== this.orderModel.totalItems) {
                this.itemCount = this.orderModel.totalItems;
                this.highlight();
            }
        }));
        this.subscriptions.add(DealEvents.currentEntitlementStatus$.subscribe(() => this.highlight()));
    }

    ngOnDestroy(): void {
        this.subscriptions.unsubscribe();
    }

    orderSummary(event: MouseEvent): void {
        event.stopPropagation();
        this.onOrderSummary.emit();
    }

    highlight(): void {
        this.highlighted = true;
        this.changeDetectorRef.markForCheck();
        setTimeout(() => {
            this.highlighted = false;
            this.changeDetectorRef.markForCheck();
        }, 3000);
    }
}



// WEBPACK FOOTER //
// ./src/app/order/order-summary-icon/order-summary-icon.component.ts